import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Input,
  Text,
  Box,
  PopoverArrow,
 
} from "@chakra-ui/react";

import { Button } from "react-bootstrap";
import { GoPencil } from "react-icons/go";

const ItemCodePopover = ({value,type,handleSave}) => {
    const [hsnValue, setHsnValue] = useState(value)

    const handleSaveHsn = (e,onClose)=>{
        e.preventDefault();
        const name = type === 'goods' ? 'hsnCode' : 'sacCode'
        handleSave(hsnValue,name)
        onClose()

    }
  return (
    <Popover placement="bottom">
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger>
                <GoPencil  size={12}  className="icon"/>
          </PopoverTrigger>
          <PopoverContent className="item-code-popover">
          <PopoverArrow className='popover-arrow' />

                <Text className="label">{type === 'goods' ? 'HSN' : 'SAC'} Code</Text>
              <Input
              className="form-controle"
                placeholder=""
                mb={2}
                value={hsnValue}
                onChange={(e)=>setHsnValue(e?.target?.value)}
              />
              <Box className="btn-footer mt-1">
                    <Button className="btn save-btn" onClick={(e)=>handleSaveHsn(e,onClose)}>Save</Button>
                    <Button className="btn cancel-btn" onClick={onClose}>Close</Button>
                  </Box>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default ItemCodePopover;
